import AnalysisPage from './Analysis'

export default AnalysisPage